export default () => {
  document.querySelectorAll(".js-scrolling-tiles-full-width").forEach((els) => {
    els
      .querySelectorAll(".js-scrolling-tiles-full-width__content")
      .forEach((el, i) => {
        // check for when the embed enters from the bottom
        const enterPageObserver = new IntersectionObserver(
          (entries, observer) => {
            // using setTimeout to ignore the affect when jump links are clicked
            entries.forEach((entry, i) => {
              if (entry.isIntersecting) {
                entry.target.classList.add(
                  "scrolling-tiles-full-width__content--in-view",
                );
                entry.target.classList.remove(
                  "scrolling-tiles-full-width__content--not-in-view",
                );
              } else {
                entry.target.classList.remove(
                  "scrolling-tiles-full-width__content--in-view",
                );
                entry.target.classList.add(
                  "scrolling-tiles-full-width__content--not-in-view",
                );
              }
            });
          },
          {
            root: null,
            rootMargin: "0px 0px -50%",
            threshold: 0,
          },
        );
        enterPageObserver.observe(el);
      });
    els
      .querySelectorAll(".js-scrolling-tiles-full-width__image")
      .forEach((el, i) => {
        const observerOptions = {
          root: null,
          threshold: [0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1],
        };
        const observerCallback = (entries) => {
          entries.forEach((entry) => {
            entry.target.style.opacity = entry.intersectionRatio;
          });
        };
        const observer = new IntersectionObserver(
          observerCallback,
          observerOptions,
        );
        observer.observe(
          el.querySelector(".js-scrolling-tiles-full-width__media-wrapper"),
        );
      });
  });
};
